var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconArrowOutward = function SvgIconArrowOutward(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54124 6.70876C6.54124 7.25876 6.99124 7.70876 7.54124 7.70876H15.1312L6.25124 16.5888C5.86124 16.9788 5.86124 17.6088 6.25124 17.9988C6.64124 18.3888 7.27124 18.3888 7.66124 17.9988L16.5412 9.11876V16.7088C16.5412 17.2588 16.9912 17.7088 17.5412 17.7088C18.0912 17.7088 18.5412 17.2588 18.5412 16.7088V6.70876C18.5412 6.15876 18.0912 5.70876 17.5412 5.70876H7.54124C6.99124 5.70876 6.54124 6.15876 6.54124 6.70876Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowOutward);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-arrow-outward.50c038cd44dd6d6d2c100e650beed75f.svg";